module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "chpass"
    }
  }, [_c('div', {
    staticClass: "content_box"
  }, [_c('div', {
    staticClass: "list_box w500"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": "輸入新密碼"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": "再次輸入新密碼"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": "6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('button', {
    staticClass: "btn_m",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("送出")]), _vm._v(" "), _c('button', {
    staticClass: "btn_n",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("回上一頁")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y_ititle"
  }, [_c('i', {
    staticClass: "fa fa-lock mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("變更密碼")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dfc0d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/Chpass.vue
// module id = 1235
// module chunks = 3